<header>
    <nav class="custom-navbar">
        <div class="nav-left-wrapper">
            <div class=" nav-left">
                <a class="d-none d-md-none d-lg-inline" href="#/dashboard"><span class="nav-brand"><img src="./assets/image/postnord.svg" alt="logo"
                            class="img-width"></span></a>
                <span class="nav-title">Distribution Planner</span>
            </div>
        </div>

        <div class="nav-group">
            <div class="nav-middle"
                *ngIf="routePage === navigation.Dashboard || routePage === navigation.Gantt|| routePage === navigation.Map
              || routePage === navigation.MainKPI || routePage === navigation.MapLeaflet || routePage === navigation.Landing">
                <span><app-notification-pop-up></app-notification-pop-up></span>
                <app-filter></app-filter>
                <span class="selected-filter-value">{{selectedDate}}</span>
                <span class="selected-filter-value">{{blName}}</span>
            </div>

            <div class="border-start nav-right-wrapper">
                <div class=" nav-right">
                    <div
                        *ngIf="routePage === navigation.Dashboard  || routePage === navigation.Gantt|| routePage === navigation.Map
                       || routePage === navigation.MainKPI || routePage === navigation.MapLeaflet || routePage === navigation.Landing">
                        <span> <img src="./assets/image/Route.svg" class="metric-icon"  pTooltip="Routes"> {{totalRoutes}}</span>
                        <span><img src="./assets/image/task_header.svg" class="metric-icon" pTooltip="Tasks"> {{totalTasks}}</span>
                        <span><img src="./assets/image/Item.svg" class="metric-icon" pTooltip="Items"> {{totalItems}}</span>
                        <span class="border-start"><i class="bi bi-grid-3x3-gap"></i></span>
                    </div>
                    <span (click)="appPanel.toggle($event)" class="header-label" 
                            pTooltip="Postnord App"
                            tooltipPosition="bottom">
                        <i class="pi pi-th-large"></i>
                    </span>
                    <span class="pointer-cursor header-label" (click)="userPanel.toggle($event)">
                        <i class="pi pi-user"></i>
                    </span>
                    <span class="label header-label">{{userName}}</span>
                </div>
            </div>
        </div>
    </nav>
    <app-nav-bar [currentUrl]="router.url">
    </app-nav-bar>
</header>

<p-popover #appPanel [dismissable]="true" [style]="{width:'360px'}">
    <ul class="app-grid-list">
        <li class="app-item" *ngFor="let app of appList" (click)="openLink(app.link)">
            <img [src]="app.icon" class="app-icon" />
            <span class="app-name">{{ app.name }}</span>
        </li>
    </ul>
</p-popover>
<p-popover #userPanel [dismissable]="true">
    <div class="user-panel">
        <div class="user-icon">
            <img src="./assets/image/pn_user.svg">
        </div>
    
        <div class="user-name text-center">
            {{ userName }}
        </div>
    
        <div class="option-section">
            <div class="option-label">Logged in as:</div>
            <div class="option-value">{{ userEmail }}</div>
        </div>
    
        <button class="logout-btn w-100 mt-3" (click)="onLogout()">
            Logout
            <i class="pi pi-sign-out ms-2"></i>
        </button>
    </div>
</p-popover>